module.exports = __webpack_public_path__ + "static/shaik-f46165a35a944c6fff21eacb60bd4201.jpg";